import { NgModule } from '@angular/core';

import { AGCheckInRatePipe } from './ag-check-in-rate.pipe';

@NgModule({
  declarations: [ AGCheckInRatePipe ],
  exports: [ AGCheckInRatePipe ],
})
export class AGCheckInRatePipeModule {}
